import React, {Component} from "react";
import {Field, reduxForm} from "redux-form/immutable";
import ActionButton from "../../components/ActionButton";
import TextInputField from "../../components/forms/TextInputField";

function upcase(val) {
  return String(val).toUpperCase();
}


class PromoCodeForm extends Component {

  render() {
    let {handleSubmit, submit, submitting} = this.props;
    let submitLabel = submitting ? "Standby" : "Apply"; 
    return (
      <form className="PromoCodeForm" onSubmit={handleSubmit}>
        <div className="title">Promo Code</div>
        <div className="inner">
          <Field 
            label="Promo Code"
            name="promoCode"
            component={TextInputField}
            normalize={upcase}
            mode=""
            table={false}
            serverError={this.props.errors.promoCode}
            />
          <ActionButton label={submitLabel} primary={true} onClick={submit} active={!submitting} />
        </div>
      </form>
    )
  }
}

const ReduxForm = reduxForm({
  form: "PromoCodeForm"
})(PromoCodeForm);

export default ReduxForm;